export const breakpoints = [480, 768, 1024, 1200, 1440]

export const heightBreakpoints = [0, 570]

export const heightTo = {
  xs: `@media screen and (max-height: ${heightBreakpoints[0]}px)`,
  sm: `@media screen and (max-height: ${heightBreakpoints[1]}px)`
}
